export default __webpack_public_path__ + "static/edengrace-b58b4c5d72ebe016671bcc1ddb8bb957.png";